export const AUTO_FINALIZE_MIN = 1;
export const AUTO_FINALIZE_MAX = 365;
export const AUTO_FINALIZE_DEFAULT = 7;

const DIGITS_ONLY = /^\d+$/;

const clamp = (value: number): number => Math.min(AUTO_FINALIZE_MAX, Math.max(AUTO_FINALIZE_MIN, value));

/** Digits-only parse with no range check. Returns null for anything else. */
const parseDigits = (input: string): number | null => {
    const trimmed = input.trim();
    if (!DIGITS_ONLY.test(trimmed)) return null;
    return Number(trimmed);
};

/** Valid whole number of days (1 to 365) after trimming, otherwise null. */
export const parseDays = (input: string): number | null => {
    const value = parseDigits(input);
    if (value === null || value < AUTO_FINALIZE_MIN || value > AUTO_FINALIZE_MAX) {
        return null;
    }
    return value;
};

/**
 * Arrow-button step. Digits outside the range step from their number and clamp.
 * Anything that is not digits steps from the default.
 */
export const stepDays = (input: string, delta: 1 | -1): number => {
    const base = parseDigits(input) ?? AUTO_FINALIZE_DEFAULT;
    return clamp(base + delta);
};

/** Initial field value: the saved days, or the default when none is saved. */
export const initialDays = (saved: number | null): number => saved ?? AUTO_FINALIZE_DEFAULT;
